/**
 * Shared UI component for UI Stat Card.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, input } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

/**
 * COMPONENT: Ui Stat Card
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'ui-stat-card',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-stat-card.component.html',
  styleUrl: './ui-stat-card.component.scss'
})
export class UiStatCardComponent {
  /** PARENT-CHILD CONTRACT: label documents the input state boundary used by this file. */
  readonly label = input('');
  /** PARENT-CHILD CONTRACT: value documents the input state boundary used by this file. */
  readonly value = input('');
  /** PARENT-CHILD CONTRACT: delta documents the input state boundary used by this file. */
  readonly delta = input('');
}
